import { Validator } from '@vista-digital/validator';
import { filmTrailerEventsValidatorSchema } from '../../trailer/types/events';
export const filmTrailerButtonEventsValidatorSchema = Object.assign(Object.assign({}, filmTrailerEventsValidatorSchema), { onPlayTrailerButtonClicked: Validator.optional(Validator.fn()) });
export const filmTrailerButtonEventsValidator = Validator.object(filmTrailerButtonEventsValidatorSchema);
